import { createSlice } from '@reduxjs/toolkit';
import { createReducerNames } from '../../../core/helpers/default';

const name = 'categoriesSelect';

const reducersKeys = {
  getDataRequest: 'getDataRequest',
  getDataSuccess: 'getDataSuccess',
  getDataFailure: 'getDataFailure',
};

const initialState = {
  data: [],
  loaded: false,
  loading: false,
  error: null,
};

const slice = createSlice({
  name,
  initialState,
  reducers: {
    [reducersKeys.getDataRequest]: (state) => {
      state.loading = true;
      state.loaded = false;
      state.payout = null;
    },
    [reducersKeys.getDataSuccess]: (state, { payload }) => {
      state.data = payload.data;
      state.loading = false;
      state.loaded = true;
    },
    [reducersKeys.getDataFailure]: (state, { payload }) => {
      state.loading = false;
      state.loaded = true;
      state.error = payload.error;
    },
  },
});

export const categoriesSelectReducers = createReducerNames(name, reducersKeys);
export const { actions } = slice;

export default slice.reducer;
